var _polygon, _circle, _line, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcoseekLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hex-grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a6b3a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0d4f2b",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leaf-grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#5cd17e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#3ab85c",
      stopOpacity: 1
    }
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "100,10 178,50 178,130 100,170 22,130 22,50",
    fill: "url(#hex-grad)",
    stroke: "#0d4f2b",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 82,
    r: 38,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5,
    opacity: 0.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 110,
    x2: 148,
    y2: 140,
    stroke: "#fff",
    strokeWidth: 6,
    strokeLinecap: "round",
    opacity: 0.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-22 C14,-18 22,-6 22,8 C22,18 14,26 0,28 C-14,26 -22,18 -22,8 C-22,-6 -14,-18 0,-22Z",
    fill: "url(#leaf-grad)",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -18,
    x2: 0,
    y2: 24,
    stroke: "#fff",
    strokeWidth: 1.5,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -8,
    x2: -12,
    y2: -2,
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 2,
    x2: -14,
    y2: 10,
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 12,
    x2: -10,
    y2: 20,
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -8,
    x2: 12,
    y2: -2,
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 2,
    x2: 14,
    y2: 10,
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 12,
    x2: 10,
    y2: 20,
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoseekLogo);
export default __webpack_public_path__ + "static/media/ecoseek-logo.1d7ae31ef898fe329e395adb139ee2f1.svg";
export { ForwardRef as ReactComponent };